export const TITLE_ICONS = {
   /* raffle: 'weeklyDraw',*/
    tournament: 'missions',
    money: 'deposit',
    freespins: 'freeSpin',
    goti: 'goti',
    bonuscode: 'bonuscode',
    sportWithTeam: 'sportWithTeam',
    vip2: 'vip2',
    Dailyraffle: 'Dailyraffle',
    wlc2k: 'wlc2k',
    other: 'other',
    race: 'race',
    funMission: 'funBonus',
    welcome: 'welcomeBonus',
    miniGames: 'miniGames',
    wofFS: 'wofFS',
    diariofs: 'diariofs',
    depositfs: 'depositfs',
    wageringwof: 'wageringwof',
    desafio: 'desafio',
};

export let GAME_BOX_ITEMS_LIST = [
  /*  'raffle',*/
    'tournament',
    'money',
    'freespins',
    'goti',
    'bonuscode',
    'vip2',
    'Dailyraffle',
    'wlc2k',
    'sportWithTeam',
    'race',
    'welcome',
    'other',
    'miniGames',
    'wofFS',
    'wageringwof',
    'diariofs',
    'depositfs',
    'desafio',
];

export const racePlayers = [
    { name: "Yuri", id: 1331867 },
    { name: "Dinho", id: 560630 },
    { name: "Moraes", id: 560635 },
    { name: "Carmona", id: 1085576 },
    { name: "Luva", id: 1600084 },
    { name: "Caiox", id: 1634429 },
    { name: "Xakaall", id: 1633328 },
    { name: "Piuzinho", id: 1632900 },
    { name: "Snopey", id: 1632854 },
    { name: "Gabepeixe", id: 1570494 },
    { name: "Acada", id: 1570487 },
    { name: "Raia", id: 1021083 },
    { name: "Papionline", id: 1755105 },
    { name: "N2online", id: 1141125 },
    { name: "Carnavalonline", id: 956314 },
    { name: "Bponline", id: 1260723 }
];

export const rankImages = {
    1: '/static/images/race/1.png',
    2: '/static/images/race/2.png',
    3: '/static/images/race/3.png',
};

export const EnumStatusesOfKyc  = {
    PENDING: 'pending',
    REJECTED: 'rejected',
    VERIFIED: 'verified',
    EXPIRED: 'expired'
}

export const levelPositions = [
    { top: 15, left: 145 },
    { top: 30, left: 375 },
    { top: 30, left: 600 },
    { top: 20, left: 800 },
    { top: 30, left: 1040 },
    { top: 25, left: 1300 },
    { top: 160, left: 1180 },
    { top: 150, left: 910 },
    { top: 185, left: 680 },
    { top: 165, left: 440 },
    { top: 190, left: 70 },
    { top: 270, left: 300 },
    { top: 280, left: 570 },
];

export const levelPositionsForSmallDsk = [
    { top: 10, left: 120 },
    { top: 30, left: 375 },
    { top: 10, left: 600 },
    { top: 20, left: 800 },
    { top: 20, left: 1040 },
    { top: 25, left: 1300 },
    { top: 130, left: 1180 },
    { top: 140, left: 910 },
    { top: 120, left: 690 },
    { top: 145, left: 435 },
    { top: 170, left: 70 },
    { top: 195, left: 300 },
    { top: 200, left: 585 },
];

export const levelPositionsForLandscape = [
    { top: 2, left: 85 },
    { top: 5, left: 250 },
    { top: 5, left: 410 },
    { top: 2, left: 600 },
    { top: 0, left: 800 },
    { top: 40, left: 980 },
    { top: 115, left: 870 },
    { top: 120, left: 680 },
    { top: 110, left: 480 },
    { top: 115, left: 265 },
    { top: 140, left: 40 },
    { top: 205, left: 205 },
    { top: 210, left: 425 },
];

export const levelPositionsMobile = [
    { top: 45, left: 245 },
    { top: 260, left: 230 },
    { top: 500, left: 245 },
    { top: 745, left: 250 },
    { top: 970, left: 240 },
    { top: 1090, left: 120 },
    { top: 850, left: 130 },
    { top: 630, left: 120 },
    { top: 380, left: 145 },
    { top: 140, left: 140 },
    { top: 25, left: 40 },
    { top: 270, left: 30 },
    { top: 500, left: 10 },
];

export const levelPositionsForSmlMobile = [
    { top: 45, left: 225 },
    { top: 260, left: 220 },
    { top: 500, left: 225 },
    { top: 745, left: 225 },
    { top: 970, left: 215 },
    { top: 1090, left: 110 },
    { top: 850, left: 120 },
    { top: 630, left: 110 },
    { top: 380, left: 125 },
    { top: 140, left: 120 },
    { top: 25, left: 30 },
    { top: 270, left: 20 },
    { top: 500, left: 5 },
];


/// less than 5 missions

export const levelPositionsForFiveMissions = [
    { top: 115, left: 20 },
    { top: 85, left: 220 },
    { top: 120, left: 395 },
    { top: 180, left: 575 },
    { top: 140, left: 770 }
]

export const levelPositionsForFiveMissionSmallDsk = [
    { top: 85, left: 20 },
    { top: 45, left: 205 },
    { top: 70, left: 400 },
    { top: 130, left: 575 },
    { top: 110, left: 770 }
]

export const levelPositionsForFiveMissionsMobile = [
    { top: 35, left: 165 },
    { top: 200, left: 45 },
    { top: 375, left: 205 },
    { top: 540, left: 60 },
    { top: 785, left: 90 },
]

export const levelPositionsForFiveMissionsLandscape = [
    { top: 70, left: 60 },
    { top: 50, left: 260 },
    { top: 140, left: 455 },
    { top: 105, left: 670 },
    { top: 140, left: 910 },
]